export default __webpack_public_path__ + "static/media/elevator_music.f1d1f1a8.mp3";